export default "<div class=\"embed-container\" ng-style=\"vm.size\"></div> ";